import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import classNames from 'classnames';

import { IOption } from 'modules/national-certificate';

import { MathJaxContext } from 'components';

import { useCheckNationalTest } from '../hooks';

interface IProps {
  testId?: number;
  isHorizontal?: boolean;
  optionsStyle?: string;
  options?: IOption[];
}

const Options: React.FC<IProps> = ({ testId, isHorizontal = false, optionsStyle, options }) => {
  const [selectedOption, setSelectedOption] = useState<number | null | undefined>(null);
  const { mutate } = useCheckNationalTest();

  const handleOptionSelect = (optionId?: number | null) => () => {
    if (optionId) {
      setSelectedOption(optionId);
    }

    mutate({
      testId,
      optionId
    });
  };

  useEffect(() => {
    const preselected = options?.find(opt => opt.is_selected);

    if (preselected) setSelectedOption(preselected.id);
  }, [options]);

  return (
    <div className={classNames({ 'grid grid-cols-1 gap-1 md:grid-cols-2': isHorizontal })}>
      {options?.map((option, index) => {
        const isSelected = selectedOption === option.id;

        return (
          <div
            key={option.id}
            className={classNames('rounded-xl border-2', {
              'border-transparent': !isSelected,
              'border-green-500 bg-green-50': isSelected
            })}
          >
            <div
              className={classNames(
                optionsStyle,
                'flex cursor-pointer items-center gap-3 rounded-xl border p-3 transition-all',
                {
                  'border-gray-200': !isSelected,
                  'border-transparent': isSelected
                }
              )}
              onClick={handleOptionSelect(option.id)}
            >
              <span className="text-lg font-semibold text-gray-600">{String.fromCharCode(97 + index)})</span>
              <div className="min-w-0 flex-1 overflow-x-auto overflow-y-hidden">
                <p className="inline-block text-sm text-gray-800 whitespace-pre-line">
                  <MathJaxContext expression={option.name} />
                </p>
                {option?.image && (
                  <div className="mt-2 flex justify-center">
                    <Image src={option.image} alt={option?.name || 'Test option'} loading="lazy" title="Test image" />
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Options;
